let isfData;
let fairgroundsData;
let foundationData;
let christmasData;

export default function createTopBarLinks(sparkThemeConfig) {
  const $topLinksSection = $('#static-top-links');
  const isSubThemeEnabled = sparkThemeConfig.enableSubTheme;

  if (isSubThemeEnabled) {
    runSubThemeConfig(sparkThemeConfig, $topLinksSection);
  } else {
    runExternalConfig(sparkThemeConfig, $topLinksSection);
  }
}

function runSubThemeConfig(sparkThemeConfig, $topLinksSection) {
  isfData = topLinksConfig.isf;
  console.log(isfData);

  fairgroundsData = {
    path: sparkThemeConfig.navItemUrl,
    label: 'Fairgrounds & Event Center',
    navType: 'item-fairgrounds',
  };
  foundationData = topLinksConfig.foundation;
  christmasData = topLinksConfig.christmas;

  renderTopItems($topLinksSection, [isfData, fairgroundsData, foundationData, christmasData]);
  renderMobileItems([isfData, fairgroundsData, foundationData, christmasData]);
}

function runExternalConfig(sparkThemeConfig, $topLinksSection) {
  isfData = topLinksConfig.isf;
  fairgroundsData = topLinksConfig.fairgrounds;
  foundationData = topLinksConfig.foundation;
  christmasData = topLinksConfig.christmas;

  renderTopItems($topLinksSection, [isfData, fairgroundsData, foundationData, christmasData]);
  renderMobileItems([isfData, fairgroundsData, foundationData, christmasData]);
}

function renderTopItems($topLinksSection, links) {
  links.forEach((link) => {
    const $a = $('<a>', {
      class: 'top-header-nav ' + link.navType,
      href: link.path,
      text: link.label,
      ...manageUrl({ href: link.path, text: link.label }),
    });

    $topLinksSection.append($a);
  });
}

function manageUrl({ href, text }) {
  const isExternal = href.startsWith('http://') || href.startsWith('https://');

  if (!isExternal) return {};

  return {
    target: '_blank',
    rel: 'noopener noreferrer',
    'aria-label': text + ' (opens in a new tab)',
  };
}

function renderMobileItems(links) {
  const mobileContainer = $('.mobile-menu-subheader');
  const html = '<div class="quick-links-mobile">';
  $(html).insertBefore(mobileContainer);

  links.forEach((link) => {
    const $a = $('<a>', {
      class: 'top-header-nav ' + link.navType,
      href: link.path,
      text: link.label,
      ...manageUrl({ href: link.path, text: link.label }),
    });

    $('.quick-links-mobile').append($a);
  });
}
